import sortBy from 'lodash-es/sortBy';
import { buttonsTemplate } from './buttonsTemplate';
import { ROUTE_NAMES } from '../../constants';

const state = {
    buttons: [],
    isSearchEnabled: false,
    isSearchBlocked: false,
    title: '',
    externalTitle: '',
    keyword: '',
};

const mutations = {
    UPDATE_BUTTON: (state, { buttonName, button }) => {
        let index = state.buttons.length ? state.buttons.findIndex(b => b.buttonName === buttonName) : -1;
        if (index !== -1) {
            state.buttons.splice(index, 1, button);
        } else {
            state.buttons = sortBy([...state.buttons, button], ['order']);
        }
    },
    REMOVE_BUTTONS: (state, buttonNames) => {
        let buttonNameArray = [].concat(buttonNames);
        state.buttons = state.buttons.filter(button => !buttonNameArray.includes(button.buttonName));
    },
    SET_SEARCH: (state, val) => {
        state.isSearchEnabled = val;
    },
    SET_SEARCH_BLOCKED: (state, val) => {
        state.isSearchBlocked = val;
    },
    SET_TITLE: (state, val) => {
        state.title = val;
        state.externalTitle = '';
    },
    SET_EXTERNAL_TITLE: (state, val) => {
        state.externalTitle = val;
        state.title = '';
    },
    SET_KEYWORD: (state, val) => {
        state.keyword = val;
    },
    CLEAR_HEADER(state) {
        state.buttons = [];
        state.isSearchEnabled = false;
        state.title = '';
        state.externalTitle = '';
    },
};

const getters = {
    searchKeyword: state => state.keyword.trim().toLowerCase(),
};

const actions = {
    configButton({ commit }, config) {
        let configsArray = Array.isArray(config) ? config : [config];
        for (let buttonConfig of configsArray) {
            let buttonDisabled =
                buttonConfig.disabled === undefined || typeof buttonConfig.disabled === 'boolean'
                    ? () => !!buttonConfig.disabled
                    : buttonConfig.disabled;
            let button = {
                ...buttonsTemplate[buttonConfig.buttonName],
                ...buttonConfig,
                action: () => {
                    commit('popup/CLEAR_MESSAGES', null, { root: true });
                    if (typeof buttonConfig.action === 'function') {
                        buttonConfig.action();
                    }
                },
                isDisabled: buttonDisabled,
            };

            commit('UPDATE_BUTTON', { buttonName: buttonConfig.buttonName, button });
        }
    },

    /**
     * Generates Undo, Add, Save buttons with input actions and disabled parameters
     * @param dispatch
     * @param undo
     * @param wasChanged
     * @param add
     * @param addDisabled
     * @param save
     * @param saveDisabled
     */
    setEditingButtons({ dispatch }, { undo, wasChanged, add, addDisabled, save, saveDisabled }) {
        dispatch('configButton', [
            {
                buttonName: 'undoButton',
                action: undo,
                disabled: wasChanged,
            },
            {
                buttonName: 'addButton',
                action: add,
                disabled: addDisabled,
            },
            {
                buttonName: 'saveButton',
                action: save,
                disabled: saveDisabled,
            },
        ]);
    },

    /**
     * Generates save and cancel buttons with input actions and disabled parameters
     * @param dispatch
     * @param cancel
     * @param save
     * @param saveDisabled
     */
    setAddingButtons({ dispatch }, { cancel, save, saveDisabled }) {
        dispatch('configButton', [
            {
                buttonName: 'cancelButton',
                action: cancel,
            },
            {
                buttonName: 'saveButton',
                action: save,
                disabled: saveDisabled,
            },
        ]);
    },

    /**
     * Generates save and undo buttons with input actions and disabled parameters
     * @param dispatch
     * @param undo
     * @param save
     * @param saveDisabled
     * @param wasChanged
     */
    setSaveUndoButtons({ dispatch }, { undo, save, saveDisabled, wasChanged }) {
        dispatch('configButton', [
            {
                buttonName: 'saveButton',
                action: save,
                disabled: saveDisabled,
            },
            {
                buttonName: 'undoButton',
                action: undo,
                disabled: wasChanged,
            },
        ]);
    },

    /**
     * Clear old title values, and set up new title.
     * @param commit
     * @param title
     */
    setHeader({ commit }, { to, from }) {
        commit('CLEAR_HEADER');

        if (from.name !== null) {
            let routes = [
                ROUTE_NAMES.WANDER_MANAGEMENT__ACCESS_GROUPS,
                ROUTE_NAMES.WANDER_MANAGEMENT__SCHEDULERS,
                ROUTE_NAMES.WIRELESS_MODULES,
                ROUTE_NAMES.REPORTS,
            ];

            let samePage = routes.some(route => {
                return from.name.includes(route) && to.name.includes(route);
            });

            if (!samePage) {
                commit('SET_KEYWORD', '');
            }
        }

        let title = (to.name ? to.name.split('.')[0] : '') + '.title';
        commit('SET_TITLE', title);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
